export const IntegrationOperation = {
  CREATE_EVENT: 'CREATE_EVENT',
  OUTBOUND_CALLBACK: 'OUTBOUND_CALLBACK',
  RUN_SCRIPT: 'RUN_SCRIPT',
  SEND_TO_IA: 'SEND_TO_IA',
  SEND_WEBHOOK: 'SEND_WEBHOOK',
  CREATE_EVENT_SIMPLE: 'CREATE_EVENT_SIMPLE',
  FORM_TRIGGER: 'FORM_TRIGGER', // Deprecated
  TRIGGER_INCIDENT: 'TRIGGER_INCIDENT',
  AUTOMATION_TRIGGER: 'AUTOMATION_TRIGGER',
  CALLABLE_TRIGGER: 'CALLABLE_TRIGGER',
  EBFD_INCIDENT_RESPONSE_TRIGGER: 'EBFD_INCIDENT_RESPONSE_TRIGGER',
  EBFD_INCIDENT_RESPONSE_SUB_TRIGGER: 'EBFD_INCIDENT_RESPONSE_SUB_TRIGGER',
  EBFD_INCIDENT_UPDATED_SUB_TRIGGER: 'EBFD_INCIDENT_UPDATED_SUB_TRIGGER',
  EBFD_INCIDENT_CLOSED_SUB_TRIGGER: 'EBFD_INCIDENT_CLOSED_SUB_TRIGGER',
  EBFD_INCIDENT_JOURNAL_UPDATED_SUB_TRIGGER:
    'EBFD_INCIDENT_JOURNAL_UPDATED_SUB_TRIGGER',
  EBFD_INCIDENT_NOTIFICATION_START_SUB_TRIGGER:
    'EBFD_INCIDENT_NOTIFICATION_START_SUB_TRIGGER',
  EBFD_INCIDENT_NOTIFICATION_STOP_SUB_TRIGGER:
    'EBFD_INCIDENT_NOTIFICATION_STOP_SUB_TRIGGER',
};

export const IntegrationOperationToTypeMap = {
  [IntegrationOperation.TRIGGER_INCIDENT]: 'FORM_TRIGGER',
  [IntegrationOperation.AUTOMATION_TRIGGER]: 'AUTOMATION_TRIGGER',
  [IntegrationOperation.EBFD_INCIDENT_RESPONSE_TRIGGER]:
    'EBFD_INCIDENT_RESPONSE_TRIGGER',
  [IntegrationOperation.EBFD_INCIDENT_RESPONSE_SUB_TRIGGER]: 'INBOUND_WEBHOOK',
  [IntegrationOperation.EBFD_INCIDENT_UPDATED_SUB_TRIGGER]: 'INBOUND_WEBHOOK',
  [IntegrationOperation.EBFD_INCIDENT_CLOSED_SUB_TRIGGER]: 'INBOUND_WEBHOOK',
  [IntegrationOperation.EBFD_INCIDENT_JOURNAL_UPDATED_SUB_TRIGGER]:
    'INBOUND_WEBHOOK',
  [IntegrationOperation.EBFD_INCIDENT_NOTIFICATION_START_SUB_TRIGGER]:
    'INBOUND_WEBHOOK',
  [IntegrationOperation.EBFD_INCIDENT_NOTIFICATION_STOP_SUB_TRIGGER]:
    'INBOUND_WEBHOOK',
};

// based on xm-api PlanIntegrationOperation.java
export const IntegrationOperationsWithScript = new Set([
  IntegrationOperation.RUN_SCRIPT,
  IntegrationOperation.CREATE_EVENT,
  IntegrationOperation.CREATE_EVENT_SIMPLE,
  IntegrationOperation.CALLABLE_TRIGGER,
]);
